<template>
	<div>
		<div class="box-top" v-for="(item, index) in dataArray" :key="index">
			<div class="left-box-top">
				<div style="font-size: 1rem;width: 100px;color: #000;font-weight: 500;">{{ item.trainstimers }} {{ item.trainstimerweek }}</div>
			</div>
			<!-- 左边 -->

			<div class="line">
				<!-- 中线 -->
				<div class="dot"></div>
			</div>

			<div class="right-box-top">
				<!-- 右边 -->
				<div class="content" style="padding: 0 1rem;font-size: 0.8rem;">
					<p style="font-size: 1.2rem;font-weight: 600;">实训内容</p>
					<div class="trianscontengt">
						<p v-for="(ite, idx) in item.transnemes" :key="ite.ids" :title="`(${ite.projectName}) ${ite.parentProjectName}`">
							{{ idx + 1 }}、({{ ite.projectName ?? '' }}) {{ ite.parentProjectName ?? '' }}
						</p>
					</div>
					<div class="mores" @click="morelist(item)" v-if="item.transallnems.length > 10">
						当前时间段共有{{ item.transallnems.length }}条实训记录，点击
						<i>查看更多信息</i>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="" :visible.sync="dialogTableVisible" center>
			<el-table :data="gridData">
				<el-table-column type="index" :index="indexMethod"></el-table-column>
				<!-- <el-table-column property="projectEndTime" label="结束时间">
					<template slot-scope="scope">
						{{ scope.row.projectEndTime }}
					</template>
				</el-table-column> -->
				<el-table-column property="TDT_StartTime" label="开始时间">
					<template slot-scope="scope">
						{{ scope.row.TDT_StartTime }}
					</template>
				</el-table-column>

				<el-table-column property="TDT_EndTime" label="结束时间">
					<template slot-scope="scope">
						{{ scope.row.TDT_EndTime }}
					</template>
				</el-table-column>

				<el-table-column property="projectName" label="项目名称"></el-table-column>
				<el-table-column property="parentProjectName" label="所属大类"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		dataArray: {
			type: Array
		}
	},
	data() {
		return {
			dialogTableVisible: false,
			gridData: []
		};
	},
	mounted() {
		// console.log(this.dataArray)
	},
	methods: {
		morelist(itm) {
			console.log(itm);
			this.dialogTableVisible = true;
			this.gridData = itm.transallnems;
		},
		gocontent(item, e) {
			// console.log(this.$parent);
			let numaobj = {
				index: 1,
				spguid: item.SP_GUID
			};
			this.$emit('myEven', numaobj);
		},
		indexMethod(index) {
			return index + 1;
		}
	}
};
</script>

<style scoped="scoped" lang="less">
.mores {
	position: absolute;
	left: 95px;
	top: 10px;
	// border: 1px solid;
	// background-color: #20a0ff;
	color: #000;
	border-radius: 10px;
	padding: 0 14px;
	cursor: pointer;
	i {
		text-transform: none;
		color: #20a0ff;
		text-decoration: underline;
	}
}

.mores:hover {
	i {
		color: #ef4f00;
	}
}

.trianscontengt {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	height: 10rem;
	align-content: flex-start;
	p {
		width: 40%;
	}
}

.wrapers {
	display: -webkit-box;
	overflow: hidden;
	white-space: normal !important;
	text-overflow: ellipsis;
	word-wrap: break-word;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}

.contenttops {
	background-color: #1db702 !important;
}

.gosucceses {
	position: absolute;
	bottom: 8%;
	right: 4%;
	// border: 1px solid #fff;
	background-color: #f0f0f0;
	border-radius: 1rem;
	color: #1db702;
	padding: 0 0.6rem;
	font-size: 0.8rem;
}

.conbotpadd {
	background-color: #f89002 !important;
	position: relative;

	.gosucces {
		position: absolute;
		bottom: 8%;
		right: 4%;
		border: 1px solid #fff;
		background-color: #fff;
		border-radius: 1rem;
		color: #f89002;
		padding: 0 0.6rem;
		font-size: 0.8rem;
	}
}

.boxtops::before {
	background-color: #1db702 !important;
}

.botpadd::before {
	background-color: #f89002 !important;
}

.activetitle {
	color: #1db702 !important;
}

.activepatitle {
	color: #f89002 !important;
}

.linetop {
	width: 10px;
	height: 100px;
	background-color: #1db702;
	position: relative;
	left: 7.8rem;
}

.box-top {
	width: 100%;
	// min-height: 260px;
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	padding: 0 1rem;
	height: 200px;
	overflow: hidden;

	.lineright {
		width: 40px;
		height: 10px;
		background: #d7d7d7;
	}

	// margin-top: 1rem;
	.content {
		// border: 1px solid;
		height: 10rem;
		position: relative;
		width: 100%;

		p {
			margin: 2px 0;
			color: #000;
			font-size: 1rem;
		}
	}

	.left-box-top {
		width: 5.2rem;
		text-align: center;
		color: rgba(198, 198, 198, 1);
		font-size: 20px;
		// margin-top: 0.6rem;
		margin-right: 1rem;
		font-weight: 600;
	}

	.line {
		width: 10px;
		background-color: #8ddece;
		margin: 0 20px 0 20px;

		.dot {
			width: 30px;
			height: 30px;
			background-color: #1abc9c;
			font-size: 2rem;
			border-radius: 50%;
			position: relative;
			left: -10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #949494;
			border: 5px solid #8ddece;
		}
	}

	// .right-box-top::before {
	// 	display: block;
	// 	content: '';
	// 	width: 6rem;
	// 	height: 10px;
	// 	margin-top: 1.6rem;
	// 	background-color: #949494;
	// }

	.right-box-top {
		flex: 1;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: row;
		height: 6rem;
		// padding: 0 0 20px 0;
	}
}

.activeline {
	background-color: #1db702 !important;
}

//激活元素
.active {
	// background-color: #1DB702 !important;
	border: 5px solid #1db702 !important;
	color: #1db702 !important;
}

// 隐藏元素
.none {
	// background-color: #D7D7D7 !important;
	border: 3px solid #ccc;
	color: #d7d7d7;
}

.activepadding {
	// background-color: #F89002 !important;
	border: 3px solid #f89002 !important;
	color: #f89002 !important;
}
</style>
